import { ChangeDetectorRef, Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Nullable } from '../../../core/common/domain/types/types';

@Component({
  selector: 'app-presence-warning-modal',
  templateUrl: './presence-warning-modal.component.html',
  styleUrls: ['./presence-warning-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PresenceWarningModalComponent implements OnDestroy {
  @Input() public countdownSeconds!: number;

  progressPercentage = 100;
  private intervalId: Nullable<number> = null;
  private readonly refreshIntervalMs = 100;
  private startedAtMs = 0;
  private totalCountdownMs = 0;

  constructor(
    private readonly modalController: ModalController,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  public ionViewWillEnter(): void {
    this.startedAtMs = Date.now();
    this.totalCountdownMs = Math.max(this.countdownSeconds, 1) * 1000;
    this.updateProgress();
    this.startProgressAnimation();
  }

  public ngOnDestroy(): void {
    this.clearInterval();
  }

  public async onContinueConnected(): Promise<void> {
    await this.modalController.dismiss(
      {
        confirmed: true,
      },
      'confirm'
    );
  }

  public async onLogout(): Promise<void> {
    await this.modalController.dismiss(
      {
        confirmed: false,
        logoutRequested: true,
      },
      'logout'
    );
  }

  private startProgressAnimation(): void {
    this.clearInterval();

    this.intervalId = window.setInterval((): void => {
      this.updateProgress();
    }, this.refreshIntervalMs);
  }

  private updateProgress(): void {
    const nowMs: number = Date.now();
    const elapsedMs: number = Math.max(nowMs - this.startedAtMs, 0);
    const remainingMs: number = Math.max(this.totalCountdownMs - elapsedMs, 0);
    const remainingRatio: number = remainingMs / this.totalCountdownMs;

    this.progressPercentage = remainingRatio * 100;
    this.changeDetectorRef.markForCheck();

    if (remainingMs <= 0) {
      this.clearInterval();
    }
  }

  private clearInterval(): void {
    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
